import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function MoreHorizIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 26 25" htmlColor={Color.Headings} {...props}>
      <path d="M7.068 14.225q-.66 0-1.13-.44a1.4 1.4 0 0 1-.469-1.06q0-.618.47-1.06.47-.44 1.13-.44.658 0 1.128.44.47.442.47 1.06a1.4 1.4 0 0 1-.47 1.06q-.47.44-1.129.44m6.15 0q-.66 0-1.13-.44a1.4 1.4 0 0 1-.469-1.06q0-.618.47-1.06.47-.44 1.129-.44.66 0 1.13.44.468.442.469 1.06 0 .62-.47 1.06t-1.129.44m6.15 0q-.66 0-1.13-.44a1.4 1.4 0 0 1-.469-1.06q0-.618.47-1.06.47-.44 1.129-.44.66 0 1.13.44.469.442.469 1.06 0 .62-.47 1.06t-1.13.44Z" />
    </MuiSvgIcon>
  );
}
export default MoreHorizIcon;
